module.exports = __webpack_public_path__ + "static/media/scene5_furba2.843dff62.wav";